
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { PackingOrder } from '../entities/packing-order';


export class PackingOrderRequest extends BaseRequest {
  
  packingOrder : PackingOrder;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.packingOrder = new PackingOrder();
  }

}